export const Police: any[] = [
  {
    name: 'Radio Patrulla 110 Cnl. Erasmo Saavedra Zabalaga',
    location: {
      address: 'C. Antonio Quijarro',
      coords: {
        lat: '-17.37460508142546',
        lng: '-66.14601109193883'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipPX0IDT-Stzdt9VOLSh2vUFWibdFFa72-1zr8hH=w426-h240-k-no'
  },
  {
    name: 'Epi Norte',
    location: {
      address: 'Av. Melchor Peréz de Olguín',
      coords: {
        lat: '-17.36158106135918',
        lng: '-66.17269164598251'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipMufulWVM7OJdzRTOdJpGTRECv6meNWXeJqPgqU=w408-h544-k-no'
  },
  {
    name: 'F.E.L.C.V.',
    location: {
      address: 'C. Baptista',
      coords: {
        lat: '-17.39078143242049',
        lng: '-66.15815619943679'
      }
    },
    photo: 'https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=p9a_8YEHRnQ5bXnAqzcF3g&cb_client=search.gws-prod.gps&w=408&h=240&yaw=247.7107&pitch=0&thumbfov=100'
  },
  {
    name: 'Utop',
    location: {
      address: 'Av. Heroínas',
      coords: {
        lat: '-17.392521856619332',
        lng: '-66.15730290935677'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipN9IZtLoGOZn9pjAlReGSBJcMbNLxczoBoJv_Nu=w408-h306-k-no'
  },
  {
    name: 'INTERPOL Dirección Departamental',
    location: {
      address: 'Final Av. Heroínas Este',
      coords: {
        lat: '-17.421216148779283',
        lng: '-66.13289702306076'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipOkRUR_IZcMU9APc-SMIwHTtBPhZ8Lb3JzdUddr=w408-h306-k-no'
  },
  {
    name: 'Fuerza Especial de Lucha Contra el Crimen FELCC',
    location: {
      address: 'Av. Circuito Bolivia',
      coords: {
        lat: '-17.40100588421513',
        lng: '-66.14628819163036'
      }
    },
    photo: 'https://sp-ao.shortpixel.ai/client/to_auto,q_glossy,ret_img,w_1080/https://www.policia.bo/wp-content/uploads/2024/06/WhatsApp-Image-2024-06-04-at-10.49.10-AM.jpeg'
  },
  {
    name: 'Estación Policial Integral (EPI)',
    location: {
      address: 'C. Punata',
      coords: {
        lat: '-17.40234208259768',
        lng: '-66.15718691978356'
      }
    },
    photo: 'https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=P_RnCXiZ8hHoH4fty7QxMQ&cb_client=search.gws-prod.gps&w=408&h=240&yaw=114.79265&pitch=0&thumbfov=100'
  },
  {
    name: 'Policía Boliviana Oficina de Transito',
    location: {
      address: 'Av. Mama Ocllo y C. Titicaca',
      coords: {
        lat: '-17.405156193446263',
        lng: '-66.16804925212939'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipMDX1on4BwIY6D_j-4rNvZVK1hLngnXHAmG81Hg=w426-h240-k-no'
  },
  {
    name: 'Modulo Policial Jaihuayco',
    location: {
      address: 'C. Colomi',
      coords: {
        lat: '-17.411958963834902',
        lng: '-66.16587854795091'
      }
    },
    photo: 'https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=1o0m7O1PtzrQoi0PXYXGug&cb_client=search.gws-prod.gps&w=408&h=240&yaw=111.16257&pitch=0&thumbfov=100'
  }
]